import { GenericService } from "./GenericService";
import { Config } from "./Config";
import { BodySecurityResponseForceEncripted } from "../utils/encripted";

export class DocumentService {
  static instance;

  constructor() {
    this.baseUrl = "document";
  }

  static getInstance() {
    if (!DocumentService.instance) {
      DocumentService.instance = new DocumentService();
    }
    return DocumentService.instance;
  }

  async handleResponse(response) {
    console.log("document handleResponse: ", response)
    let respObject = response.data.data;

    if (respObject.ResponseCode !== 0) {
      const responseObject = {
        message: `${respObject.Messages ?? respObject.Message} ${respObject.TansactionId ? respObject.TansactionId : ""
          } ${respObject.statusText ? respObject.statusText : ""}`,
      };
      console.log('handleResponse respObject ', respObject, responseObject)
      const error = respObject?.Body || responseObject;
      return Promise.reject(error);
    }
    return respObject?.Body === undefined || respObject?.Body === null ? {
      Body:
        respObject?.Response !== undefined && respObject?.Response !== null ?
          respObject.Response
          : respObject
    } : respObject;
  }

  async handleResponseForceEncripted(response) {
    console.log('handleResponseForceEncripted response ', response)
    var respObject = BodySecurityResponseForceEncripted(response.data.data);
    console.log('BodySecurityResponseForceEncripted respObject ', respObject)
    if (respObject.ResponseCode !== 0) {
      var responseObject = {
        message: `${respObject.Messages ?? respObject.Message} ${respObject.TansactionId ? respObject.TansactionId : ""
          } ${respObject.statusText ? respObject.statusText : ""}`,
      };
      // console.log('BodySecurityResponseForceEncripted respObject IsOK responseObject ', responseObject)
      const error = respObject?.Body || responseObject;
      return Promise.reject(error);
    }

    return respObject?.Body === undefined || respObject?.Body === null ? { Body: respObject } : respObject;
  }

  async handleDocument(response, extension) {
    let respObj = response.data;
    console.log("--------.........respObj----------------------------: ", respObj)
    //Create a Blob from the PDF Stream
    const blob = new Blob([respObj.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    const url = window.URL.createObjectURL(blob);
    console.log("--------.........url----------------------------: ", url)
    return url;
  }

  async VerifyTraceSignConfiguration(data) {
    const response = await GenericService.get({
      endpoint: `${this.baseUrl}/VerifyTraceSignConfiguration?file_Id=${data}`,
      data: Config.setParametersForceEncripted(data, true),
      config: Config.configAuth(),
    });
    return response.data
  }

  async VerifyTraceSignConfigurationMasive(data) {
    console.log('VERIFICARFIRMAS', data)
    const response = await GenericService.get({
      endpoint: `${this.baseUrl}/VerifyTraceSignConfigurationMasive?file_Id=${data}`,
      data: Config.setParametersForceEncripted(data, true),
      config: Config.configAuth(),
    });
    return response.data
  }

  async RegisterDocumentFieldData(data) {
    console.log("RegisterDocumentFieldData data: ", data)
    const response = await GenericService.post({
      endpoint: `${this.baseUrl}/RegisterDocumentFieldData`,
      data: data,
      config: Config.configAuth(),
    });
    const dataRes = await this.handleResponse(response);
    console.log("RegisterDocumentFieldData: dataRes ", dataRes)
    return dataRes;
  }

  async AddTraceSignDocumentMasive(data) {
    const response = await GenericService.post({
      endpoint: `${this.baseUrl}/AddTraceSignDocumentMasive`,
      data: data,
      config: Config.configAuth(),
    });
    const dataRes = await this.handleResponse(response);
    return dataRes;
  }

  async DeleteTraceSignDocumentMasive(data) {
    const response = await GenericService.get({
      endpoint: `${this.baseUrl}/DeleteTraceSignDocumentMasive?file_Id=${data}`,
      data: data,
      config: Config.configAuth(),
    });
    const dataRes = await this.handleResponse(response);
    return dataRes;
  }

  async DeleteTraceSignDocument(data) {
    console.log('DataGetDocument', data)
    const response = await GenericService.get({
      endpoint: `${this.baseUrl}/DeleteTraceSignDocument?file_Id=${data}`,
      config: Config.configAuth(),
    });
    console.log('responseDeleteDataTrace', response)
    return response;
  };

  async GetDocumentToSignContent(data) {
    const response = await GenericService.post({
      endpoint: `${this.baseUrl}/GetDocumentToSignContent`,
      data: data,
      config: Config.configAuth(),
    });
    const dataRes = await this.handleResponse(response);
    return dataRes;
  }

  async UploadTemplate(data) {
    console.log("UploadTemplate data request: ", data)
    const response = await GenericService.post({
      endpoint: `${this.baseUrl}/UploadTemplate2`,
      data: data,
      config: Config.configAuth(),
    });
    const dataRes = await this.handleResponse(response);
    console.log("UploadTemplate: dataRes ", dataRes)
    return dataRes;
  };

  async UploadTemplate2(data) {
    console.log('UploadTemplate request-----------: ', data)
    var formData = new FormData();
    formData.append('FileName', data.FileName);
    formData.append('FileContent', data.FileContent);
    formData.append('Extension', data.Extension);
    formData.append('Category_Id', data.CategoryId);
    formData.append('CategoryName', data.CategoryName);
    formData.append('Estatus', data.Estatus);
    console.log('UploadTemplate formData--------: ', formData)

    const response = await GenericService.post({
      endpoint: `${this.baseUrl}/UploadTemplate`,
      data: formData,
      config: Config.configAuth(),
    });
    console.log('UploadTemplate response-------------------: ', response)
    const dataRes = await this.handleResponse(response);
    return dataRes;
  };

  async ReOrderDocument(data) {
    console.log("ReOrderDocument", data)
    const response = await GenericService.post({
      endpoint: `${this.baseUrl}/OrderDocument`,
      data: data,
      config: Config.configAuth(),
    });
    console.log('responseReorder', response )
    return response;
  };


}